import { Row } from 'utils/models';
import { WorklistData, WorklistStatus } from 'models/worklist';

export const DataFieldNames = {
  title: 'title',
  priority: 'priority',
  timestamp: 'timestamp',
  patient: 'patientName',
  birthday: 'patientBirthday',
  groupName: 'groupName',
  status: 'status',
};

type RowType = Row<WorklistData>;

export const getWorkListRow = (): RowType => {
  return {
    renderOverlay: (item) => item.status === WorklistStatus.Read,
  };
};
